import React from "react";
import { Box, Tooltip } from "@mui/material";
import { AlertCircle } from "lucide-react";
import { useTheme } from "../theme/useTheme.js";
import { useAuth } from "./contexts/AuthContext.jsx";

/**
 * Featurebase button component that redirects users to their respective
 * Featurebase portal based on their role.
 * - superadmin: https://markezy.featurebase.app/
 * - agency_admin/consultant: https://serseostack.featurebase.app/
 * - client: Not shown
 */
export const FeaturebaseButton = () => {
  const { theme, neutrals } = useTheme();
  const { user } = useAuth();

  // Don't show for client users or if no user
  if (!user || user.role === "client") {
    return null;
  }

  // Determine the URL based on user role
  const getFeaturebaseUrl = () => {
    if (user.role === "superadmin") {
      return "https://markezy.featurebase.app/";
    }
    // agency_admin and consultant go to the same URL
    return "https://serseostack.featurebase.app/";
  };

  const handleClick = () => {
    window.open(getFeaturebaseUrl(), "_blank", "noopener,noreferrer");
  };

  return (
    <Tooltip title="Reportar problema" arrow placement="bottom">
      <Box
        sx={{
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 40,
          height: 40,
          borderRadius: "50%",
          cursor: "pointer",
          transition: "background-color 150ms",
          "&:hover": {
            backgroundColor: neutrals.gray[100],
          },
        }}
        onClick={handleClick}
      >
        <AlertCircle size={20} color={theme.palette.text.secondary} />
      </Box>
    </Tooltip>
  );
};

export default FeaturebaseButton;
